import { TASK_TYPES } from 'constants/notification';
import { createSelector } from 'reselect';
import { IAppState } from 'types';

export const selectNotificationState = (state: IAppState) => state.notification;

export const selectNotifications = createSelector(
  selectNotificationState,
  (notification) => notification.notifications,
);

export const getNotificationCount = createSelector(
  selectNotificationState,
  (notification) => notification.notifications.filter((n) => !n.seen).length,
);

export const getMarketScanReadyNotifications = createSelector(
  selectNotificationState,
  (notification) =>
    notification.notifications.filter(
      (n) => !n.seen && n.notificationType === TASK_TYPES.POLICY_SCAN_READY,
    ),
);

export const getMarketScanPendingNotifications = createSelector(
  selectNotificationState,
  (notification) =>
    notification.notifications.filter(
      (n) => !n.seen && n.notificationType === TASK_TYPES.POLICY_SCAN_PENDING,
    ),
);
